import React, { Fragment, useState } from 'react';
import * as Func from '../../../../../../helpers/functions';
import { ListComponent } from 'containers/backend/common/component/Index';
import delete_icon from 'assets/images/delete_icon.png';
import './styles.less';
import { Modal } from 'antd';

const ListCols = ['ipAddress', 'name', 'properties', 'url', 'delete'];

const WhitelistIpListing = (props) => {
  const {isLoading, listAppUI, paging, onChangeTable, permissionActions} = props;
  const titleItemTable = Func.getTitleTable(ListCols, [],[]);
  const [currentSelectedIp, setCurrentSelectedIp] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    if (currentSelectedIp) {
      props.deleteWhitelistIp(currentSelectedIp);
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setCurrentSelectedIp(null);
  };
  const deleteIp = (e) => {
    const currentTarget = e.currentTarget;
    if (permissionActions && permissionActions.allowDeleteIp) {
      const id = currentTarget.getAttribute('data-id');
      setCurrentSelectedIp(id);
      showModal();
    }
  }
  const componentTable = {
      ipAddress: {
          key: "ipAddress",
          width: 300,
          render: (text, record) => {
              return(
                  <Fragment>
                      {record.ip}
                  </Fragment>
              )
          }
      },
      name: {
          align: 'center',
          key: "name",
          render: (text, record) => {
            return(
              <Fragment>
                  {record.name}
              </Fragment>
            )
          }
      },
      properties: {
          align: 'center',
          key: "properties",
          render: (value, record) => {
            return(
              <Fragment>
                  {record.propertyName}
              </Fragment>
            )
          }
      },
      url: {
        align: 'center',
        key: "url",
        render: (text, record) => {
          return(
            <Fragment>
                {record.url}
            </Fragment>
          )
        }
      },
      delete: {
        align: 'center',
        key: "action",
        render: (value, record) => {
          return(
            <Fragment>
                <button
                  className='delete_ip'
                  data-id={record.id}
                  data-ip={record.ip}
                  data-name={record.name}
                  data-property-name={record.propertyName}
                  data-property-id={record.propertyId}
                  onClick={deleteIp}
                >
                  <img src={delete_icon} />
                </button>
            </Fragment>
          )
        }
    },
  };

  return (
    <div>
      <ListComponent
        tableKey="appUI-list"
        classChildren="p-0" classParent="m-0"
        rowKey={(record, k) => record.id ? record.id : k}
        loading={{ spinning: isLoading, size: 'large' }}
        dataSource={listAppUI}
        onChange={onChangeTable}
        columns={Func.columnsTable({
            titleTable: titleItemTable,
            component: componentTable,
            itemName: 'app'
        })}
        pagination={{ total: paging.current.totalCount, pageSize: paging.current.pageSize, current: paging.current.pageIndex}}
      />
      <Modal title="Thông báo" visible={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        <p>Bạn có đồng ý xóa IP này không?</p>
      </Modal>
    </div>
  )
};

export default WhitelistIpListing;
